import React, { useRef, useEffect } from 'react';
import './VideoLoop.css';

const VideoLoop = ({ src }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log("Video autoplay failed:", error);
      });
    }
  }, []);

  return (
    <div className="video-loop-container">
      <video
        ref={videoRef}
        className="video-loop"
        playsInline
        autoPlay
        muted
        loop
      >
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoLoop; 